module.exports = __webpack_public_path__ + "img/selfservice1.76c9f553.jpg";